import axios from "axios";
import React from "react";
import { AnswerFileResult } from "../../../store/viewmodels/AnswerFileViewModel";
import { Student } from "../../../store/viewmodels/StudentViewModel";
import { getFileElement } from "../../../utils/TaskContentServices";

export interface ResultsFilesProps {
    student?: Student,
    close: () => void
}

function ResultsFiles(props: ResultsFilesProps): JSX.Element {
    if (!props.student) return <></>;

    let allFiles = props.student.answer_files;
    let videoResults = [] as JSX.Element[];
    if (allFiles) {
        for (let i: number = 0; i < allFiles?.length; i++) {
            let resultRow = <VideoRecordingListItem key={"videorecording_result" + allFiles[i].id} answerFile={allFiles[i]} student={props.student} />;
            videoResults.push(resultRow);
        }
    }

    const buttonRow = (
        <div className="grid grid-cols-2 gap-2">
            <div className="col-span-1 col-start-2">
                <button type="button" onClick={props.close} className={"block w-full border-transparent text-sm font-medium rounded-md text-white bg-gray-500 hover:bg-gray-400 focus:shadow-outline font-bold py-2 px-4 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"}>Sulje</button>
            </div>
        </div>
    );

    return (
        <div className="py-3 h-full w-full overflow-auto">
            <div className="py-3 flex border-b border-gray-200">
                <div className="flex flex-grow  pt-2 pb-2">
                    <div className="">
                        <h1 className="ml-4 text-2xl font-extrabold text-gray-900">{props.student?.identification}</h1>
                        <h1 className="ml-4 text-2xl text-gray-500">{props.student?.username}</h1>
                    </div>
                </div>
                <div className="w-1/2 mr-2">
                    {buttonRow}
                </div>
            </div>
            {videoResults}
            <div className="py-3 float-right w-1/2 mr-2">
                {buttonRow}
            </div>
        </div>
    );
}

interface VideoRecordingListItemProps {
    student: Student
    answerFile: AnswerFileResult
}

function VideoRecordingListItem(props: VideoRecordingListItemProps): JSX.Element {
    const downloadFile = (id: number, filename: string) => {
        const URL: string = window.location.href.includes('localhost') ? 'http://localhost:8000/api/answerfiles/' + id + '/get_video/' : '/api/answerfiles/' + id + '/get_video/'
        axios({
            url: URL,
            method: 'GET',
            responseType: 'blob',
        }).then((response) => {
            const blob = new Blob([response.data]);
            const videoURL = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = videoURL;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
        });
    }

    let downLoad: JSX.Element = <div className="text-red-500">Ei tiedostoa</div>;
    let watchVideo: JSX.Element = <div className="text-red-500">Ei tiedostoa</div>;

    const [closeButton, setCloseButton] = React.useState(<></>);
    const [show, setShow] = React.useState(<></>);

    function closeVideo() {
        setShow(<></>);
        setCloseButton(<></>);
    }

    function showVideo(file: AnswerFileResult | undefined) {
        if (!file) return;


        let videoElement = getFileElement(file);
        setShow(videoElement);

        let close = (
            <button className="block" type="button" onClick={() => closeVideo()} >
                <span className="ri-close-fill text-4xl text-teal-500 hover:text-teal-400"></span>
            </button>
        );
        setCloseButton(close);
    }

    const splittedFullFileName = props.answerFile.file.split('/');
    const decodedFileName = decodeURI(splittedFullFileName[splittedFullFileName.length - 1]);

    let fileName = splittedFullFileName[splittedFullFileName.length - 1].replace(props.student.username + "_", '')
    fileName = fileName.replace(".mp4", '')
    const splittedFileName = fileName.split('_');
    const timeSplitted = splittedFileName.slice(splittedFileName.length - 5, splittedFileName.length);
    const timeString = timeSplitted[0] + "." + timeSplitted[1] + "." + timeSplitted[2] + " klo " + timeSplitted[3] + ":" + timeSplitted[4];

    const itemset = props.answerFile.itemset ? props.answerFile.itemset : -1;
    const item = props.answerFile.item?.name;
    let itemsetName = "";

    if (itemset !== -1) {
        let activeItemsets = props.student.active_item_sets;
        for (let i: number = 0; i < activeItemsets.length; i++) {
            if (activeItemsets[i].id === itemset) {
                itemsetName = activeItemsets[i].name;
            }
        }
    }

    downLoad = (
        <button className="block" type="button" onClick={() => downloadFile(props.answerFile?.id!, decodedFileName)}>
            <span className="ri-file-download-line text-4xl text-teal-500 hover:text-teal-400"></span>
        </button>);

    watchVideo = (
        <button className="" type="button" onClick={() => showVideo(props.answerFile)}>
            <span className="ri-movie-line text-4xl text-teal-500 hover:text-teal-400"></span>
        </button>
    );

    return (
        <div className="grid grid-cols-3 py-2 mx-4">
            <div className="my-auto" key={"fileItem-" + props.answerFile.id}>
                <div className="text-teal-500 font-bold">{itemsetName}</div>
                <div className="font-semibold">{item}</div>
                <div>{timeString}</div>
            </div>
            <div className="text-center m-auto justify-center" key={"download-" + props.answerFile.id}>{downLoad}</div>
            <div>
                <div className="text-center m-auto justify-center flex" key={"watchVideo-" + props.answerFile.id}>
                    {watchVideo}
                    {closeButton}
                </div>
                {show}
            </div>
        </div>
    );
}

export default ResultsFiles;